



































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import Dots from "@/components/Dots.vue";
import { Cathegory } from "@/shared/cathegory";

@Component({
  components: {
    Dots,
  },
})
export default class CathegoryNav extends Vue {
  active = 0;
  open = false;
  large = false;
  cathegories: Cathegory[] = [];
  $refs: any;

  getNor(cathegory: Cathegory): string {
    if (cathegory.allreadyRequested) {
      if (cathegory.content.length > 99) {
        return "99+";
      }
      return cathegory.content.length + "";
    }
    return "";
  }

  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, true);
    this.cathegories = Object.values(this.$store.getters.cathegories);
    this.cathegories = this.cathegories.sort(
      (a: any, b: any) => a.sort - b.sort
    );
  }
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize, true); 
  }
  onResize() {
    this.large = this.$refs.nav.clientWidth >= 1390;
  }
  @Emit("change")
  onChange(index: number) {
    this.active = index;
    this.open = false;
    return this.cathegories[index].id;
  }
}
